import React, { Dispatch, ReactNode, SetStateAction, useEffect, useState } from "react"
import Select from "react-select"
import { Common } from "lib/types"
import { customStyles, Label, SelectContainer } from "./SingleSelect.styled"

type Props = {
  options: Common.Option[]
  // eslint-disable-next-line
  setValue?: Dispatch<SetStateAction<any>>
  defaultValue?: Common.Option | null
  placeholder?: string
  useCustomOnChange?: boolean
  handleOnChange?: () => void
  label?: string | ReactNode
  disabled?: boolean
  /**
   * @deprecated Use ProtectedInput wrapper instead of overrideDisabled
   * This prop is kept for backward compatibility but will be removed in future versions
   */
  overrideDisabled?: boolean
  updateDefaultValue?: boolean
  formatOptionLabel?: (data: Common.Option) => ReactNode
}
// eslint-disable-next-line
const SingleSelect: React.FC<Props> = React.forwardRef<any, Props>(
  (
    {
      options,
      setValue,
      defaultValue,
      placeholder,
      useCustomOnChange,
      handleOnChange,
      label,
      disabled,
      overrideDisabled,
      formatOptionLabel,
      updateDefaultValue,
      ...props
    }: Props,
    ref
  ) => {
    const [selectedOption, setSelectedOption] = useState<Common.Option | null>(defaultValue ?? null)

    useEffect(() => {
      setValue && setValue(selectedOption)
    }, [selectedOption, setValue])

    useEffect(() => {
      updateDefaultValue && setSelectedOption(defaultValue ?? null)
    }, [defaultValue])

    const isDisabled = () => {
      if (disabled) return disabled
      if (overrideDisabled !== undefined) return !overrideDisabled
      return false
    }

    return (
      <SelectContainer $invalid={false} {...props}>
        {label && <Label>{label}</Label>}
        <Select
          value={selectedOption}
          placeholder={placeholder}
          ref={ref}
          onChange={useCustomOnChange ? () => handleOnChange : (e) => setSelectedOption(e)}
          options={options}
          isDisabled={isDisabled()}
          formatOptionLabel={formatOptionLabel}
          styles={customStyles}
        />
      </SelectContainer>
    )
  }
)

SingleSelect.displayName = "SingleSelect"

export default SingleSelect
